module.exports = __webpack_public_path__ + "static/4-8ccadd7701f37919d0aab4f9520e857e.png";